import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path, Circle } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M3.447 5.4c0-.22.179-.4.4-.4h3.866a.4.4 0 110 .8H3.847a.4.4 0 01-.4-.4z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.113 2.934c-.589 0-1.066.477-1.066 1.066v7.334c0 .589.477 1.066 1.066 1.066h1.352a1.512 1.512 0 01.092-.8H2.113a.267.267 0 01-.266-.266V4c0-.147.12-.266.266-.266h7.334c.147 0 .266.119.266.266v7.6H6.336a1.495 1.495 0 01.093.8h4.084V4c0-.589-.477-1.066-1.066-1.066H2.113z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 4.94666,
    cy: 12.1667,
    r: 1.1,
    stroke: color !== null && color !== void 0 ? color : '#000',
    strokeOpacity: 0.87,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 12.28,
    cy: 12.1667,
    r: 1.1,
    stroke: color !== null && color !== void 0 ? color : '#000',
    strokeOpacity: 0.87,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.512 5.734h1.85c.118 0 .223.078.256.193l1.533 5.333a.267.267 0 01-.256.34h-.226a1.495 1.495 0 01.093.8h.133c.71 0 1.22-.68 1.025-1.361l-1.534-5.333a1.067 1.067 0 00-1.025-.772h-1.85v.8zm.286 6.666a1.522 1.522 0 01.093-.8h-.384v.8h.291z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;